import { put } from 'redux-saga/effects';
import { showSnackbar } from '../Snackbar/snackbar.actions';

export function* usernameOrPasswordMissing() {
  yield put(
    showSnackbar({
      message: 'Please fill in username and password',
      type: 'error',
    })
  );
}

export function* wrongLdapCredentials() {
  yield put(
    showSnackbar({
      message: 'Login failed. Please check your LDAP credentials',
      type: 'error',
    })
  );
}

export function* missingHeadlineOrSublineOfTeaser() {
  yield put(
    showSnackbar({
      message: 'Pleaser provide a headline and a subline',
      type: 'error',
    })
  );
}



// WEBPACK FOOTER //
// ./src/store/Errors/errors.saga.ts